import PropTypes from "prop-types"
import React from "react"

const IconRow = ({ icon, title, detail }) => (
  <div className="flex items-start space-x-3">
    <i className={`${icon} mt-1 text-teal-600`} />
    <div className="flex flex-col">
      <span className="font-semibold text-gray-900">{title}</span>
      <span className="text-gray-700">{detail}</span>
    </div>
  </div>
)

IconRow.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  detail: PropTypes.string,
}

const Section = ({ heading, rows }) => (
  <div>
    <h4 className="mb-4 mt-0 font-semibold text-gray-700">{heading}</h4>
    <div className="flex flex-col space-y-4">
      {rows.map((row) => (
        <IconRow
          key={row.title}
          icon={row.icon}
          title={row.title}
          detail={row.detail}
        />
      ))}
    </div>
  </div>
)

Section.propTypes = {
  heading: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      detail: PropTypes.string,
    })
  ).isRequired,
}

const RequirementsCard = ({
  insuranceRequired,
  registrationRequired,
  copy,
}) => {
  if (!insuranceRequired && !registrationRequired) return null

  return (
    <div className="flex flex-col space-y-6 rounded-lg border border-gray-300 px-4 py-6">
      {insuranceRequired && (
        <Section
          heading={copy.insuranceRequirementsHeading}
          rows={[
            {
              icon: "fa-solid fa-shield-check",
              title: copy.insuranceRequirementsActivePolicy,
              detail: copy.insuranceRequirementsActivePolicyDetail,
            },
            {
              icon: "fa-solid fa-circle-check",
              title: copy.insuranceRequirementsVisible,
              detail: copy.insuranceRequirementsVisibleDetail,
            },
          ]}
        />
      )}
      {registrationRequired && (
        <Section
          heading={copy.registrationRequirementsHeading}
          rows={[
            {
              icon: "fa-solid fa-id-card",
              title: copy.registrationRequirementsCurrent,
              detail: copy.registrationRequirementsCurrentDetail,
            },
            {
              icon: "fa-solid fa-circle-check",
              title: copy.registrationRequirementsVisible,
              detail: copy.registrationRequirementsVisibleDetail,
            },
          ]}
        />
      )}
    </div>
  )
}

RequirementsCard.propTypes = {
  insuranceRequired: PropTypes.bool,
  registrationRequired: PropTypes.bool,
  copy: PropTypes.shape({
    insuranceRequirementsHeading: PropTypes.string,
    insuranceRequirementsActivePolicy: PropTypes.string,
    insuranceRequirementsActivePolicyDetail: PropTypes.string,
    insuranceRequirementsVisible: PropTypes.string,
    insuranceRequirementsVisibleDetail: PropTypes.string,
    registrationRequirementsHeading: PropTypes.string,
    registrationRequirementsCurrent: PropTypes.string,
    registrationRequirementsCurrentDetail: PropTypes.string,
    registrationRequirementsVisible: PropTypes.string,
    registrationRequirementsVisibleDetail: PropTypes.string,
  }).isRequired,
}

export default RequirementsCard
